import { Icon } from '@chakra-ui/react';

const PCHeaderIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<g>
				<path class="st0" d="M28.4,28.1H16.85v-2.04h2.23c0.6,0,1-0.15,1.18-0.43c0.03-0.04,0.16-0.3,0.16-1.51v-8.47H9.54v8.61
			c0,1.15,0.12,1.37,0.13,1.4c0.21,0.27,0.61,0.42,1.18,0.42h2.37v2.04H1.6v-2.04h2.46c0.29,0,0.51-0.05,0.67-0.16
			c0.15-0.1,0.26-0.25,0.34-0.45c0.02-0.07,0.07-0.34,0.07-1.34V5.74c0-1.2-0.17-1.49-0.23-1.55C4.84,4.11,4.61,3.94,3.8,3.94H1.6
			V1.9h11.62v2.04h-2.37c-0.79,0-1.02,0.17-1.08,0.24C9.72,4.24,9.54,4.54,9.54,5.74v7.47h10.88V5.74c0-1.27-0.17-1.54-0.21-1.58
			c-0.03-0.04-0.24-0.22-1.14-0.22h-2.23V1.9H28.4v2.04h-2.35c-0.57,0-0.78,0.09-0.84,0.13c-0.13,0.08-0.25,0.24-0.34,0.48
			c-0.01,0.04-0.08,0.3-0.08,1.39v18.3c0,1.13,0.13,1.35,0.14,1.37c0.23,0.3,0.68,0.44,1.34,0.44h2.13V28.1z M17.59,27.35h10.06
			v-0.54h-1.38c-0.91,0-1.56-0.25-1.93-0.73c-0.14-0.18-0.3-0.54-0.3-1.83V5.94c0-1.15,0.07-1.49,0.12-1.66
			c0.16-0.4,0.38-0.68,0.64-0.85c0.26-0.17,0.67-0.25,1.24-0.25h1.6V2.65H17.59v0.54h1.48c0.88,0,1.42,0.15,1.7,0.47
			c0.18,0.21,0.39,0.64,0.39,2.07v8.22H8.79V5.74c0-1.08,0.13-1.71,0.41-2.04c0.29-0.34,0.83-0.5,1.65-0.5h1.62V2.65H2.35v0.54H3.8
			c0.83,0,1.38,0.16,1.67,0.5c0.28,0.32,0.41,0.97,0.41,2.04v18.37c0,1.1-0.06,1.42-0.1,1.57L5.77,25.7
			c-0.13,0.35-0.34,0.62-0.62,0.81c-0.28,0.19-0.65,0.29-1.09,0.29H2.35v0.54h10.12v-0.54h-1.62c-0.82,0-1.42-0.24-1.78-0.72
			c-0.14-0.19-0.28-0.55-0.28-1.84v-9.35h12.38v9.22c0,1.34-0.15,1.73-0.29,1.93c-0.33,0.51-0.94,0.76-1.81,0.76h-1.48V27.35z"/>
			</g>
		</g>

	</Icon>
);

export default PCHeaderIcon;
